<script setup lang="ts"></script>

<template>
	<div
		class="w-screen h-screen relative flex justify-center items-center p-6"
	>
		<div class="flex flex-col justify-center items-center gap-6">
			<img
				alt="flag"
				src="/images/sedna_time_out.svg"
				class="fill-black w-60 h-60"
			/>
			<h1 class="text-dark font-bold text-justify leading-8">
				مدرسه سدنا امروز بسته است، ولی نگران نباش! فردا منتظرت هستیم با
				کلی انیمیشن جدید و جذاب!
			</h1>
			<p class="text-dark text-justify leading-8">
				خارج از محدوده بازه زمانی وارد شده‌اید. در صورتی که عضو اصلی
				هستید برای وارد شدن به سایت تماشا کننده را تغییر دهید.
				<NuxtLink to="/panel/accounts">
					<a
						class="text-primary cursor-pointer hover:text-primaryHover"
						>تغییر تماشا کننده</a
					>
				</NuxtLink>
			</p>
		</div>
	</div>
</template>

<style scoped></style>
